// @flow
import React, { Component, Fragment } from 'react';
import { BaseActions } from 'store/actionCreators';

import './SettingPassword.scss';

type Props = {
  onChangePassword: (password: string) => Promise<any>,
};

type State = {
  password1: string,
  password2: string,
};

class SettingPassword extends Component<Props, State> {
  state = {
    password1: '',
    password2: '',
  };

  onChangePassword1 = (e: SyntheticInputEvent<HTMLInputElement>) => {
    this.setState({
      password1: e.target.value,
    });
  };

  onChangePassword2 = (e: SyntheticInputEvent<HTMLInputElement>) => {
    this.setState({
      password2: e.target.value,
    });
  };

  onConfirm = async () => {
    const { password1, password2 } = this.state;
    if (password1.length < 5 || password2.length < 5) {
      BaseActions.showToast({ type: 'error', message: '6자 이상 입력해주세요.' });
      return;
    }
    if (password1 !== password2) {
      BaseActions.showToast({ type: 'error', message: '비밀번호가 일치 하지 않습니다.' });
      return;
    }
    try {
      await this.props.onChangePassword(password1);
      this.setState({
        password1: '',
        password2: '',
      });
    } catch (e) {
      console.log(e);
    }
  };

  render() {
    const { password1, password2 } = this.state;
    return (
      <div className="SettingPassword">
        <div className="password-card">
          <div className="section-header">
            <h3>비밀번호 변경</h3>
            <p>새로운 비밀번호를 설정하여 계정을 안전하게 보호하세요</p>
          </div>

          <div className="password-form">
            <div className="form-group">
              <label className="form-label" htmlFor="password1-input">
                새 비밀번호
                <input
                  id="password1-input"
                  className="form-input"
                  type="password"
                  value={password1}
                  autoComplete="new-password"
                  placeholder="6자 이상의 새 비밀번호를 입력하세요"
                  onChange={this.onChangePassword1}
                />
              </label>
            </div>

            <div className="form-group">
              <label className="form-label" htmlFor="password2-input">
                새 비밀번호 확인
                <input
                  id="password2-input"
                  className="form-input"
                  type="password"
                  value={password2}
                  autoComplete="new-password"
                  placeholder="비밀번호를 다시 한 번 입력하세요"
                  onChange={this.onChangePassword2}
                />
              </label>
            </div>
          </div>

          <div className="security-info">
            <div className="info-icon">
              <span role="img" aria-label="보안">
                🔒
              </span>
            </div>
            <div className="info-text">
              <strong>보안 안내</strong>
              <p>안전한 비밀번호를 위해 6자 이상의 영문, 숫자, 특수문자를 조합해 주세요.</p>
            </div>
          </div>

          <div className="form-actions">
            <button className="confirm-button" onClick={this.onConfirm}>
              비밀번호 변경
            </button>
          </div>
        </div>
      </div>
    );
  }
}

export default SettingPassword;



// WEBPACK FOOTER //
// ./src/components/settings/SettingPassword/SettingPassword.js